import { render } from "./kaihuResult.vue?vue&type=template&id=5b47a444&scoped=true"
import script from "./kaihuResult.vue?vue&type=script&lang=js"
export * from "./kaihuResult.vue?vue&type=script&lang=js"

import "./kaihuResult.vue?vue&type=style&index=0&id=5b47a444&scoped=true&lang=css"

import exportComponent from "D:\\AestProject\\EducationOrg\\qianhedu-master\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b47a444"]])

export default __exports__